export const formatRequestDetails = (details) => {
  const type = details.type === "transcrito" ? "Transcrito" : "Áudio web"

  return [
    {
      description: "Protocolo",
      value: details.protocolNumber
    },
    {
      description: "Data",
      value: details.createdDate
    },
    {
      description: "Forma de disponibilização",
      value: type
    },
    {
      description: "Forma de envio",
      value: details.format
    },
    {
      description: "E-mail de envio",
      value: details.email,
      last: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/AudioRequest/utils.js